import {IoMdRibbon} from "react-icons/io";
import {Link} from "react-router-dom";
import './CongratulationsWidget.scss';
import {useContext, useEffect, useState} from "react";
import API, {HandleError} from "../API";
import {PracticeCategory} from "../models/PracticeCategory";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import {useTranslation} from "react-i18next";

export default function CongratulationsWidget() {
    const { t, i18n } = useTranslation();
    const app = useContext(AppContext)
    const [categories, setCategories] = useState([])
    const { enqueueSnackbar } = useSnackbar()


    useEffect(() => {
        getCategories()

    }, [app.user.current_course])

    const getCategories = async () => {
        try {
            const res = await API({
                method: 'GET',
                url: `/practice/${app.user.current_course}/categories?slim=1`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {
                    slim: 1
                }
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            let categories = res.data.items.map((jsonData, idx) => {
                return new PracticeCategory(jsonData)
            })
            setCategories(categories)
        }
        catch(e) {
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <div className="dashboard-widget widget-congratulations">
        <div className="widget-body">
            <div className="widget-congratulations-text">
                <IoMdRibbon className="ribbon"/>
                <h3>{t('congrats.title')}</h3>
                <div className="mb-3 text-muted">
                    <small>
                        {t('congrats.text1')}
                        <br />
                        {t('congrats.text2')}
                    </small>
                </div>
            </div>
            {categories.length > 0 ?
            <div className="congrats-practice-text">
                <h3>{t('congrats.practice.title')}</h3>
                <div className="mb-3 text-muted">
                    <small>{t('congrats.practice.subtitle')}</small>
                </div>
                <ul className="ul-links">
                    {categories.map((item, idx) => {
                        if(idx > 3)
                            return false;
                        else if(idx === 3)
                            return <li key={'cpt-id-' + idx}>
                                <Link to="/practice"><strong>{t('congrats.practice.viewAll')}</strong></Link>
                            </li>

                        return <li key={'cpt-id-' + idx}>
                            <Link to="/practice" state={{ initialCategory: item.ID }}>{item.name}</Link>
                        </li>
                    })}
                </ul>
            </div> : <></>}
            <div className="congrats-simulation-text">
                <h3>{t('congrats.cbr.title')}</h3>
                <div className="mb-3 text-muted">
                    <small>{t('congrats.cbr.subtitle')}</small>
                </div>
                <ul className="ul-links">
                    <li>
                        <Link to="/simulation">{t('congrats.cbr.link')}</Link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
}